const assets = {
  settings: require('./icons/setting2.svg').default,
  chatGpt: require('./icons/chatgpt-icon.png'),
  cohere: require('./icons/Cohere.svg').default,
  gpt4: require('./icons/image-4.png'),
  ai21: require('./icons/A121.svg').default,
  picasso: require('./icons/stableDiffusion.svg').default,
  huggingFace: require('./images/huggingFace.png'),
  tick: require('./icons/tick.png'),
  userAvatar: require('./images/user-avatar.png'),
  userAvatar2: require('./images/user-avatar-1.png'),
  stripeCards: require('./images/stripe-cards.png'),
  closeIcon: require('./icons/close-icon.svg').default,
  giftIcon: require('./images/gift.png'),
  info: require('./icons/info.png'),
  card: require('./icons/card.svg').default,
  logo: require('./icons/brand-logo.svg').default,
  chevronLeft: require('./icons/chevronLeft.svg').default,
  user: require('./icons/user.svg').default,
  star: require('./icons/star.svg').default,
  users: require('./icons/users.svg').default,
  invoices: require('./icons/invoices.svg').default,
  book: require('./icons/book.svg').default,
  eye: require('./icons/eye.svg').default,
  eyeslash: require('./icons/eyeslash.svg').default,
  copy: require('./icons/copy.svg').default,
  arrowDown: require('./icons/arrowdown.svg').default,
  arrowLeft: require('./icons/arrowLeft.svg').default,
  close: require('./icons/close.svg').default,
  burger: require('./icons/burger.svg').default,
  profileUpdate: require('./icons/profile-update.svg').default,
  copyButton: require('./icons/clipboardtick.svg').default,
  bell: require('./icons/bell.svg').default,
  arrowRightGreen: require('./icons/arrowRightGreen.svg').default,
  tickGreen: require('./icons/tick.svg').default,
  infoRed: require('./icons/infoRed.svg').default,
  googleIcon: require('./icons/googleIcon.png'),
  whatsapp: require('./icons/whatsapp.svg').default,
  facebook: require('./icons/facebook.svg').default,
  twitter: require('./icons/twitter.svg').default,
  linkedIn: require('./icons/linkedin.svg').default,
  sms: require('./icons/sms.svg').default,
  like: require('./icons/like.svg').default,
  dislike: require('./icons/dislike.svg').default,
  share: require('./icons/share.svg').default,
  starOutlined: require('./icons/starOutlined.svg').default,
  edit: require('./icons/edit.svg').default,
  delete: require('./icons/delete.svg').default,
  correct: require('./icons/correct.svg').default,
  false: require('./icons/xcross.svg').default,
  starFilled: require('./icons/starFilled.svg').default,
  likeFilled: require('./icons/likeFilled.svg').default,
  dislikeFilled: require('./icons/dislikeFilled.svg').default,
  temp1: require('./images/temp1.png'),
  temp2: require('./images/temp2.png'),
  temp3: require('./images/temp3.png'),
  triangleArrow: require('./icons/triangleArrow.svg').default,
  check: require('./icons/check.svg').default,
  download: require('./icons/download.svg').default,
  expand: require('./icons/expand.svg').default,
  selected: require('./icons/selected.svg').default,
  help: require('./icons/help.svg').default,
  bg: require('./images/bg.svg').default,
  discount: require('./images/discount.png'),
  post: require('./images/post.png'),
  signup: require('./icons/signup.svg').default,
  preview: require('./images/preview.png'),
  menu: require('./icons/menu.svg').default,
  message: require('./icons/message.svg').default,
  settingsWhite: require('./icons/settings-white.svg').default,
  checked: require('./icons/checked.svg').default,
  uncheck: require('./icons/uncheck.svg').default,
  plus: require('./icons/plus.svg').default,
  custom: require('./icons/custom.svg').default,
  noFilter: require('./images/noFilter.png'),
  midJourney: require('./icons/midJourney.svg').default,
  eyeSlash: require('./icons/eye-slash.svg').default,
  salesBg: require('./images/sales-bg.png'),
  cyberMondayPrice: require('./icons/cyberMondayPrice.svg').default,
  icon: require('./icons/icon.svg').default,
  backIcon: require('./icons/backIcon.svg').default,
  giftsIcon: require('./icons/gift-icon.svg').default,
  send: require('./icons/send.svg').default,
  email: require('./icons/email.svg').default,
  christmas: require('./images/christmas.png'),
  xmas: require('./images/xmas.png'),
  giftBanner: require('./images/gift-banner.png'),
  9: require('./icons/9.svg').default,
  90: require('./icons/90.svg').default,
};

export default assets;
